"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = exports.Cell = exports.TableColumn = void 0;
const zod_1 = require("zod");
exports.TableColumn = zod_1.z.object({
    name: zod_1.z.string(),
    field: zod_1.z.string(),
    type: zod_1.z.string().optional(),
    textAlign: zod_1.z.string().optional(),
    with: zod_1.z.string().optional()
});
exports.Cell = zod_1.z.object({
    cellIndex: zod_1.z.number(),
    column: exports.TableColumn,
    rowData: zod_1.z.object({}),
    value: zod_1.z.string(),
    className: zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.string()), zod_1.z.object({})])
});
exports.Row = zod_1.z.object({
    rowIndex: zod_1.z.number(),
    cells: zod_1.z.array(exports.Cell),
    className: zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.string()), zod_1.z.object({})])
});
//# sourceMappingURL=types.js.map